import React from "react";
import Routers from "./routes/Routers";
import "./App.css";
import UserProvider from "./components/userComponents/UserContext";

const App = () => {
  return (
    <UserProvider>
      <Routers />
    </UserProvider>
  );
};

export default App;
